var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3185 0.219727V24.2197H0.318481V0.219727H24.3185Z",
    fill: "#FFE9FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3185 1.21973V25.2197H0.318481V1.21973H24.3185Z",
    fill: "#FFE9FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1526 14.765L11.9104 17.798C11.226 17.8197 10.5859 18.2559 10.3427 18.9138C10.0807 19.7075 10.3899 20.6568 11.1196 21.0684L14.5102 22.3457C14.7554 22.4757 15.0281 22.5416 15.3009 22.5416C15.5964 22.5416 15.8898 22.4648 16.1567 22.3112L19.5393 20.3496C20.337 19.8847 20.6177 18.8557 20.1686 18.0472L18.4916 14.6468C18.207 14.1593 17.6781 13.8472 17.1464 13.8472C16.9307 13.8472 16.7121 13.8925 16.5033 13.988L14.2719 15.0771L13.1088 13.0682C12.8833 12.6684 12.5131 12.3828 12.0719 12.2637C11.9242 12.2243 11.7745 12.2046 11.6258 12.2046C11.3284 12.2046 11.0349 12.2824 10.771 12.436C9.95663 12.9067 9.68187 13.9506 10.1526 14.765V14.765Z",
    stroke: "#1D1B1B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8799 11.1778C14.4239 11.6809 16.3185 11.9613 16.3185 11.2204C16.3185 7.90632 13.6322 5.21973 10.3185 5.21973C7.00477 5.21973 4.31848 7.90632 4.31848 11.2204C4.31848 13.0479 5.16862 14.6828 6.47162 15.7825C7.07479 16.2916 8.10795 14.5363 8.10795 13.747C8.10795 11.8283 9.6632 10.2729 11.5816 10.2729C12.4877 10.2729 13.2818 10.6246 13.8799 11.1778Z",
    fill: "#1D1B1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaint);
export default __webpack_public_path__ + "static/media/icon_paint.c81861520eb39a32620ac1989f59605a.svg";
export { ForwardRef as ReactComponent };